import { addOrUpdateMediaGroup } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddMediaGroup = () => {
    const entityUpdater = useEntityQueryUpdate();

    const addMediaGroupMutation = useMutation({
        mutationKey: 'add_media_group',
        mutationFn: (model) => {
            const { id = null, ...rest } = model;
            return addOrUpdateMediaGroup(id, rest);
        },
        onSuccess: (data) => {
            entityUpdater(data);
            entityUpdater([['media_group'], ['media_group', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully created media group',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addMediaGroupMutation;
};
export default useAddMediaGroup;
